import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, getFormValues, reduxForm} from 'redux-form';

import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import {withStyles} from '@mui/styles';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import {Autocomplete} from '@mui/material';
// import Printicon from '@mui/icons-material/Print';
import {} from '@mui/lab';
import {} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {
  isNull,
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {attachorderOperations} from '../../../../reducks/attachorder';
import {commonOperations} from '../../../../reducks/common';
import {renderCheckbox, renderSelect, renderSelectMultiLine, renderTextField} from '../../../atoms/CustomPart.js';
import MainContainer from '../../../organisms/MainContainer.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
// import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import MuiTooltip from '../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
import {Tooltip} from '@grapecity/wijmo';
// import {toggleClass} from '@grapecity/wijmo';
import {CellType} from '@grapecity/wijmo.grid';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import SaveIcon from '@mui/icons-material/Save';
import {
  FormControl,
  FormGroup,
} from '@mui/material';
import {getSessionObject, setSessionObject} from '../../../../common/Session.js';
import PaperPart from '../../../atoms/PaperPart.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import CustomMultiRow, {createComponents} from '../../../molecules/CustomMultiRow.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import withRouter from '../../../organisms/withRouter.js';
import * as validateRule from '../../../validateRule.js';
import MdHistory from '../../TstkKasyo/MdHistory';
import YotiInfo from '../../TstkKasyo/YotiInfo';
import CustomerInfo from '../CustomerInfo';
import RowAdd from '../RowAdd';
import TkResultAll from '../TkResultAll';
import TkInfo from '../TkInfo/index.js';
import SharedSetting from '../../TstkKasyo/SharedSetting';
import TsInfo from '../TsInfo/index.js';

// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_KASYO_LIST.name, href: ''},
];

// パンくずパラメータ（調査・点検登録・報告一覧画面から遷移の場合）
const transitionListReport = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_RESULT_REPORT_LIST.name,
    href: GMN_PATH.TSTK_RESULT_REPORT_LIST},
  {gmnName: GMN.TSTK_KASYO_LIST.name, href: ''},
];

const styles = (theme) => ({

});

const autoCompleteItems = [
  {senroMskn: '北（ｷﾀｶﾝ）', code: 'A00001'},
  {senroMskn: 'ﾐﾅﾐｶﾝ', code: 'A00002'},
  {senroMskn: '東（ﾋｶｼｶﾝ）', code: 'A00003'},
  {senroMskn: 'ﾆｼｶﾝ', code: 'A00004'},
];


// 一覧
const kenViews = {
  nwJigyosyo: {binding: 'nwJigyosyo', header: '旧NW事業所', groupHeader: '', dataType: 'String', width: 80, isReadOnly: true, height: 120},
  blockNo: {binding: 'blockNo', header: 'ブロック番号', groupHeader: '', dataType: 'String', width: 65, isReadOnly: true},
  customerName: {binding: 'customerName', header: 'お客さま名', groupHeader: '基本情報', dataType: 'link', width: 195, isReadOnly: true},
  slName: {binding: 'slName', header: '線路名', dataType: 'String', groupHeader: '基本情報', width: 125, isReadOnly: true},
  tsTkUserName: {binding: 'tsTkUserName', header: '担当者', groupHeader: '基本情報', dataType: 'String', dataMap: null, width: 100, isReadOnly: false},
  supplyPointNo: {binding: 'supplyPointNo', header: '供給地点特定番号', groupHeader: '基本情報', dataType: 'String', width: 195, isReadOnly: true},
  dtNo: {binding: 'dtNo', header: '電柱番号', dataType: 'String', groupHeader: '基本情報', width: 125, isReadOnly: true},
  tsTkDate: {binding: 'tsTkDate', header: '予定年月', dataType: 'String', dataMap: null, groupHeader: '基本情報', width: 100, isReadOnly: false},

  tkButton: {binding: 'tkButton', header: '詳細', groupHeader: '調査・点検結果', dataType: 'cellMaker', width: 70, isReadOnly: true, cssClass: 'bf-centerPos'},
  togeNo: {binding: 'togeNo', header: '共用番号', groupHeader: '調査・点検結果', dataType: 'link', width: 110, isReadOnly: true},
  tkHikomiSen: {binding: 'tkHikomiSen', header: '引込線', groupHeader: '調査・点検結果', dataType: 'String', width: 95, isReadOnly: true, cssClass: 'bf-centerPos'},
  tkKeki: {binding: 'tkKeki', header: '計器', groupHeader: '調査・点検結果', dataType: 'String', width: 80, isReadOnly: true, cssClass: 'bf-centerPos'},
  tkDtNo: {binding: 'tkDtNo', header: '電柱番号', groupHeader: '調査・点検結果', dataType: 'String', width: 110, isReadOnly: true, cssClass: 'bf-centerPos'},
  tkMemo: {binding: 'tkMemo', header: 'メモ', groupHeader: '調査・点検結果', dataType: 'String', width: 48, isReadOnly: true, cssClass: 'bf-centerPos'},
  tkStatus: {binding: 'tkStatus', header: '工程状況', groupHeader: '調査・点検結果', dataType: 'link', width: 95, isReadOnly: true, cssClass: 'bf-centerPos'},
  tkUserName: {binding: 'tkUserName', header: '点検担当者', groupHeader: '調査・点検結果', dataType: 'String', width: 90, isReadOnly: true},
  tkDate: {binding: 'tkDate', header: '点検年月日', groupHeader: '調査・点検結果', dataType: 'String', width: 90, isReadOnly: true},

  tsButton: {binding: 'tsButton', header: '詳細', groupHeader: '調査・点検結果', dataType: 'cellMaker', width: 70, isReadOnly: true, cssClass: 'bf-centerPos'},
  togeType: {binding: 'togeType', header: '代表区分', groupHeader: '調査・点検結果', dataType: 'String', width: 110, isReadOnly: true, cssClass: 'bf-centerPos'},
  tsKasyo: {binding: 'tsKasyo', header: '調査状況', groupHeader: '調査・点検結果', dataType: 'String', width: 95, isReadOnly: true, cssClass: 'bf-centerPos'},
  // tsSaiTyosa: {binding: 'tsSaiTyosa', header: '再調査', groupHeader: '調査・点検結果', dataType: 'cellMaker', width: 80, isReadOnly: true, cssClass: 'bf-centerPos'},
  tsSaiTyosa: {binding: 'tsSaiTyosa', header: '再調査', groupHeader: '調査・点検結果', dataType: 'cellMaker', width: 80, isReadOnly: true, cssClass: 'bf-centerPos'},
  tsBlack: {binding: 'tsSaiTyosaStatus', header: '再調査状況', groupHeader: '調査・点検結果', dataType: 'String', width: 110, isReadOnly: true, cssClass: 'bf-centerPos'},
  tsMemo: {binding: 'tsMemo', header: 'メモ', groupHeader: '調査・点検結果', dataType: 'String', width: 48, isReadOnly: true, cssClass: 'bf-centerPos'},
  tsStatus: {binding: 'tsStatus', header: '工程状況', groupHeader: '調査・点検結果', dataType: 'link', width: 95, isReadOnly: true, cssClass: 'bf-centerPos'},
  tsUserName: {binding: 'tsUserName', header: '調査担当者', groupHeader: '調査・点検結果', dataType: 'String', width: 90, isReadOnly: true},
  tsDate: {binding: 'tsDate', header: '調査年月日', groupHeader: '調査・点検結果', dataType: 'String', width: 90, isReadOnly: true},

  // tsTkYoteiDate: {binding: 'tsTkYoteiDate', header: '予定日', groupHeader: '', dataType: 'String', width: 90, readOnly: true},
  // tsTkYoteiUserName: {binding: 'tsTkYoteiUserName', header: '予定者', groupHeader: '', dataType: 'String', width: 90, readOnly: true},
  // taisyoYM: {binding: 'taisyoYM', header: '実施年月', groupHeader: '', dataType: 'String', width: 80, readOnly: true},
  dataMotiDasi: {binding: 'dataMotiDasi', header: '持出状況', groupHeader: '', dataType: 'link', width: 60, isReadOnly: true, cssClass: 'bf-centerPos'},
  // memo: {binding: 'memo', header: 'メモ', groupHeader: '', dataType: 'String', width: 80, readOnly: true},
  customerType: {binding: 'customerType', header: 'お客さま区分', groupHeader: '', dataType: 'String', width: 90, isReadOnly: true, visible: false},
  dtType: {binding: 'dtType', header: '引込線電柱番号区分', groupHeader: '', dataType: 'String', width: 90, isReadOnly: true, visible: false},

};

const filtersBindings = [
  'nwJigyosyo', 'blockNo', 'customerName', 'slName', 'tsTkUserName', 'supplyPointNo', 'dtNo', 'tsTkDate',
  'togeNo', 'tsKasyo', 'tsSaiTyosa', 'tsStatus', 'tsSaiTyosaStatus',
  'togeType', 'tkHikomiSen', 'tkKeki', 'tkDtNo', 'tkStatus',
  'taisyoYM', 'dataMotiDasi',
];

/**
 * 調査・点検箇所一覧画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
      modalOpen: false,
      modalOpenDntYoti: false,
      dntYotiInfo: { // 渡すパラメータ
        supplyPointNo: null,
        customerName: null,
      },
      tkInfo: {
        supplyPointNo: null,
      },
      tsInfo: {
        supplyPointNo: null,
      },
      sharedSettingInfo: {
        dtNo: null,
      },
      tokuteiNo: [],
      hikikomiNo: {},
    };
    this.gridRef = React.createRef();
    this._gridItems = {};
    this._fields = [];
    this.setGridItems();
    // this.setInitValue();
    this.tooltip = new Tooltip();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
      this.setGridItems();
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // 遷移セッションのデータをクリアする
    let params = {
      lastMenu: '',
    };

    // 調査・点検箇所一覧画面に遷移
    setSessionObject(GMN.TSTK_KASYO_LIST.id, params);
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const dataKen =[
      {nwJigyosyo: '広島NWC', blockNo: '10001', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789011', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', tsKasyo: '', tsSaiTyosa: '', tsMemo: '', tsStatus: '未着手', tsSaiTyosaStatus: '', tsUserName: '田中  一郎', tsDate: '2026/11/16', tkHikomiSen: '', tkKeki: '', tkDtNo: '', tkMemo: '', tkStatus: '未着手', tkUserName: '田中  一郎', tkDate: '2026/11/16', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', dataMotiDasi: '持出中', customerType: '1'},
      {nwJigyosyo: '広島NWC', blockNo: '10002', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789012', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '代表', tsKasyo: '', tsSaiTyosa: '', tsMemo: '', tsStatus: '未着手', tsUserName: '田中  一郎', tsDate: '2026/11/16', tkHikomiSen: '', tkKeki: '', tkDtNo: '', tkMemo: '', tkStatus: '未着手', tkUserName: '田中  一郎', tkDate: '2026/11/16', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', dataMotiDasi: '持出中', customerType: '2'},
      {nwJigyosyo: '広島NWC', blockNo: '10003', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789013', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '1', tsSaiTyosaStatus: '調査完了', tsMemo: '有', tsStatus: '報告中', tsUserName: '田中  一郎', tsDate: '2026/11/16', tkHikomiSen: '良', tkKeki: '良', tkDtNo: '番号相違', tkMemo: '有', tkStatus: '報告中', tkUserName: '田中  一郎', tkDate: '2026/11/16', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', dataMotiDasi: '持出中', customerType: '3', hiKetuFlagTs: 'true', hiKetuFlagTk: 'true'},
      {nwJigyosyo: '広島NWC', blockNo: '10004', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789014', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '', tsSaiTyosaStatus: '調査完了', tsMemo: '有', tsStatus: '報告中', tsUserName: '田中  一郎', tsDate: '2026/11/16', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '有', tkStatus: '報告中', tkUserName: '田中  一郎', tkDate: '2026/11/16', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', dataMotiDasi: '解除', customerType: '4'},
      {nwJigyosyo: '広島NWC', blockNo: '', customerName: '追加11　田中小学校ー', supplyPointNo: '', slName: '', dtNo: '123 321 456 123', memo: '箇所追加メモ', customerType: '5'},

      {nwJigyosyo: '広島NWC', blockNo: '10005', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789015', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '1', tsSaiTyosaStatus: '調査中', tsMemo: '', tsStatus: '承認中', tsUserName: '田中  一郎', tsDate: '2026/11/16', tkHikomiSen: '不良', tkKeki: '不良', tkDtNo: '', tkMemo: '有', tkStatus: '承認中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', customerType: ''},
      {nwJigyosyo: '広島NWC', blockNo: '10006', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789016', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '1', tsSaiTyosaStatus: '調査済', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', customerType: '2'},
      {nwJigyosyo: '広島NWC', blockNo: '10007', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789017', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', customerType: '4', hiKetuFlagTs: 'true', hiKetuFlagTk: 'true'},
      {nwJigyosyo: '広島NWC', blockNo: '10008', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789018', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', customerType: '', hiKetuFlagTs: 'false', hiKetuFlagTk: 'true'},
      {nwJigyosyo: '広島NWC', blockNo: '10009', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789019', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', customerType: '', hiKetuFlagTs: 'true', hiKetuFlagTk: 'false'},
      {nwJigyosyo: '広島NWC', blockNo: '10010', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789020', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', customerType: ''},
      {nwJigyosyo: '広島NWC', blockNo: '10011', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789021', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '代表', tsKasyo: '調査完了', tsSaiTyosa: '', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', customerType: ''},
      {nwJigyosyo: '広島NWC', blockNo: '10012', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789022', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '代表', tsKasyo: '調査完了', tsSaiTyosa: '', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', tsTkYoteiDate: '2026/11/20 AM', tsTkYoteiUserName: '田中  一郎', taisyoYM: '2026/04', dataMotiDasi: '解除', customerType: ''},
      {nwJigyosyo: '広島NWC', blockNo: '10015', customerName: '田中小学校ー', supplyPointNo: '1234567890123456789025', slName: '線路NNNNNNN', dtNo: '123 321 456 123', tsTkDate: '2026/11', tsTkUserName: '田中  一郎', togeNo: 'N0000000001', togeType: '', tsKasyo: '調査完了', tsSaiTyosa: '', tsMemo: '', tsStatus: '報告中', tkHikomiSen: '良', tkKeki: '不要', tkDtNo: '', tkMemo: '', tkStatus: '報告中', dataMotiDasi: ''},
      {nwJigyosyo: '広島NWC', blockNo: '', customerName: '追加12　田中小学校ー', supplyPointNo: '', slName: '', dtNo: '123 321 456 123', memo: '箇所追加メモ', customerType: '5'},


    ];

    for (const data of dataKen) {
      let notes = {};
      if (data.tkMemo && data.tkMemo.length > 0) {
        notes.tkMemo = '引込線点検メモ内容';
      }
      if (data.tsMemo && data.tsMemo.length > 0) {
        notes.tsMemo = '定期調査メモ内容';
      }
      if (data.tkUserName && data.tkUserName.length > 0) {
        notes.tkUserName = '調査会社：工業組合</br>調査機関事業所：広島北支</br>ユーザID：TB0001</br>ユーザ名：' + data.tkUserName;
      }
      if (data.tsUserName && data.tsUserName.length > 0) {
        notes.tsUserName = '調査会社：工業組合</br>調査機関事業所：広島北支</br>ユーザID：TB0001</br>ユーザ名：' + data.tsUserName;
      }
      if (Object.keys(notes).length) {
        data.notes = notes;
      }
    }

    this.gridRef.current.setItemsSource(dataKen);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        // bRet = true;
      }
      const count = this.gridRef.current.selectedItemCount()/2;
      const items = this.gridRef.current.selectedItem();
      for (let rowIndex = count - 1; rowIndex >= 0; rowIndex --) {
        const customerType =items[rowIndex*2]._data.customerType;
        if (customerType === '5') {
          bRet = true;
        }
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
      this.setState({
        hikikomiNo: 'NNNN012H01H03',
        // hikikomiNo: items[0].dataItem.blockNo,
      });
    } catch (error) {

    }
  };

  /**
   * データ持出履歴ダイアログを開く
   * @param {object} e イベント
   * @param {object} ctx 選択したデータ
  */
  openDntYoti = (e, ctx) => {
    // 変更履歴を残すために一覧の編集を確定する
    // this.gridRefTusin.current?.commitAndCheck();
    // this.gridRefKiki.current?.commitAndCheck();

    this.setState({
      modalOpenDntYoti: true,
      dntYotiInfo: {
        supplyPointNo: ctx.item.supplyPointNo,
        customerName: ctx.item.customerName,
      },
    });
  };

  /**
   * データ持出情報参照用ダイアログを閉じる
   */
  closeDntYoti = () => {
    this.setState({
      modalOpenDntYoti: false,
      dntYotiInfo: {
        supplyPointNo: '',
        customerName: '',
      },
    });
  };

  /**
   * 点検入力ダイアログを開く
   * @param {*} item 点検データ
  */
  openTkInfo = (item) => {
    this.setState({
      modalOpenTkInfo: true,
      tkInfo: {
        supplyPointNo: item.supplyPointNo,
        tkStatus: item.tkStatus,
      },
    });
  };

  /**
   * 点検入力用ダイアログを閉じる
   * @param {*} data
   */
  closeTkInfo = (data) => {
    console.log(data);
    this.setState({
      modalOpenTkInfo: false,
      tkInfo: {
        supplyPointNo: data.supplyPointNo,
        tkHikomiSen: data.tkHikomiSen,
        tkKeki: data.tkKeki,
        tkDtNo: data.tkDtNo,
        tkMemo: data.tkMemo,
        btnFlag: data.btnFlag,
      },
    });
  };

  /**
   * 調査入力ダイアログを開く
   * @param {*} item 調査データ
  */
  openTsInfo = (item) => {
    this.setState({
      modalOpenTsInfo: true,
      tsInfo: {
        supplyPointNo: item.supplyPointNo,
        tsKasyo: item.tsKasyo,
      },
    });
  };

  /**
   * 調査入力用ダイアログを閉じる
   * @param {*} data
   */
  closeTsInfo = (data) => {
    console.log(data);
    this.setState({
      modalOpenTsInfo: false,
      tsInfo: {
        supplyPointNo: data.supplyPointNo,
        btnFlag: data.btnFlag,
      },
    });
  };

  /**
   * 持出履歴画面の表示
   */
  displayMdHistory = () => {
    this.setState({
      showMdHistoryModal: true,
      modalKey: Date.now(),
    });
  };

  /**
  * 持出履歴画面を閉じる
  */
  closeMdHistory = () => {
    this.setState({
      showMdHistoryModal: false,
      modalKey: 0,
    });
  };

  /**
   * 共用設定画面の表示
   *  @param {*} dtNo 電柱番号
   */
  displaySharedSetting = (dtNo) => {
    // const tokuteiNo=[];
    // const items =this.gridRef.current.selectedItem();
    // // 削除
    // for (let rowIndex = 1; rowIndex<=this.gridRef.current.selectedItemCount;
    //   rowIndex ++) {
    //   tokuteiNo.push(items[rowIndex].dataItem.tkDtNo);
    // }
    this.setState({
      showSharedSettingModal: true,
      sharedSettingInfo: {
        dtNo: dtNo,
      },

    });
  };

  /**
  * 共用設定画面を閉じる
  */
  closeSharedSetting = () => {
    this.setState({
      showSharedSettingModal: false,
    });
  };

  /**
   * 承認状況画面の表示
   */
  displayApprovalStatus = () => {
    this.setState({
      showApprovalStatusModal: true,
    });
  };

  /**
 * 承認状況画面を閉じる
 */
  closeApprovalStatus = () => {
    this.setState({
      showApprovalStatusModal: false,
    });
  };

  /**
   * 承認画面の表示
   *  @param {object} tstkFlag イベント
   * @param {object} approvalType 選択したデータ
   */
  displayApprovalComment = (tstkFlag, approvalType) => {
    this.setState({
      showApprovalCommentModal: true,
      tstkFlag: tstkFlag,
      approvalType: approvalType,
    });
  };

  /**
 * 承認画面を閉じる
 */
  closeApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: false,
    });
  };

  /**
   * 調査・点検箇所追加画面の表示
   */
  displayRowAdd = () => {
    this.setState({
      showRowAddModal: true,
    });
  };

  /**
 * 調査・点検箇所追加画面を閉じる
 */
  closeRowAdd = () => {
    this.setState({
      showRowAddModal: false,
    });
  };

  /**
   * お客さま情報画面の表示
   */
  displayCustomerInfo = () => {
    this.setState({
      showCustomerInfoModal: true,
    });
  };

  /**
 * お客さま情報画面を閉じる
 */
  closeCustomerInfo = () => {
    this.setState({
      showCustomerInfoModal: false,
    });
  };

  /**
   * 点検結果一括画面の表示
   */
  displayTkResultAll = () => {
    this.setState({
      showTkResultAllModal: true,
    });
  };

  /**
 * 点検結果一括画面を閉じる
 */
  closeTkResultAll = () => {
    this.setState({
      showTkResultAllModal: false,
    });
  };


  doSave = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['登録'],
      },
    });
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['報告'],
      },
    });
  };

  doApprove = () => {
    this.setState({
      showRowAddModal: true,
    });
  };

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['確認'],
      },
    });
  };
  /**
   * 追加ボタン押下時
   */
  doAdd = () => {
    let data = this.props.values;
    this.setState({modalOpen: true, gamenData: data});
  };

  /**
   * 調査・点検箇所追加内容の取得
   * @param {*} items
   */
  getRowAdd = (items) => {
    let selectItems = items;
    console.log(selectItems);
    let tebleData = this.gridRef.current.grid.rows.length;
    // let tebleData2 = selectItems.length;
    let list = [];
    // list = dataKen;
    // let c = 0;
    for (let i = 0; i < tebleData; i++ ) {
      if ((i+1) % 2 !== 0) {
        let a = this.gridRef.current.grid.rows[i].dataItem;
        list.push(a);
      }
    }
    let b = {nwJigyosyo: '広島NWC', blockNo: '', customerName: '追加　田中小学校ー', supplyPointNo: '', slName: '', dtNo: '123 321 456 123', memo: '箇所追加メモ', customerType: '5'};

    list.push(b);
    this.gridRef.current.setItemsSource(list);
    // let data = this.state.gamenData;
    // this.props.doSetInitValues(data);
    this.setState({showRowAddModal: false});
  };

  /**
   * 引込線共用設定処理
   * @param {*} items
   */
  sharedSettingExe = (items) => {
    // 引込線共用設定処理.
    this.setState({
      showSharedSettingModal: false,
    });
  };

  /**
   * 点検結果一括の設定内容
   * @param {*} items
   */
  getTkResultAll = (items) => {
    let selectItems = items;
    console.log(selectItems);
    let tebleData = this.gridRef.current.grid.rows.length;
    // let tebleData2 = selectItems.length;
    let list = [];
    // list = dataKen;
    // let c = 0;
    for (let i = 0; i < tebleData; i++ ) {
      if ((i+1) % 2 !== 0) {
        let a = this.gridRef.current.grid.rows[i].dataItem;
        a.tkHikomiSen='良';
        a.tkKeki='良';
        list.push(a);
      }
    }
    // let b = {customerName: '田中000追加', dtNo: '123 H56 789 012'};
    // let b = {nwJigyosyo: '広島NWC', blockNo: '', customerName: '追加田中小学校ー', supplyPointNo: '', slName: '', dtNo: '123 321 456 123', memo: '箇所追加メモ', customerType: '5'};

    // list.push(b);
    this.gridRef.current.setItemsSource(list);
    // let data = this.state.gamenData;
    // this.props.doSetInitValues(data);
    this.setState({showTkResultAllModal: false});
  };

  doClose = () => {
  // 請求情報データを画面に設定
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
    this.setState({showRowAddModal: false});
  };

  /**
   * 取消ボタン押下時
   */
  doDelete = () => {
    let _warningMessages = null;
    try {
      if (!this.gridRef ||
      !this.gridRef.current) {
        return;
      }
      // 未選択チェック
      const count = this.gridRef.current.selectedItemCount()/2;
      if (count === 0) {
        this.props.doShowMessage({
          message: {
            id: 'BFY000023E',
            values: ['取消'],
          },
        });
        return;
      }
      const items = this.gridRef.current.selectedItem();
      let cv = this.gridRef.current.grid.collectionView;
      cv.beginUpdate();
      // 削除
      for (let rowIndex = count - 1; rowIndex >= 0; rowIndex --) {
        let removeIndex = (items[rowIndex*2].index);
        removeIndex=Math.ceil(removeIndex/2);
        cv.removeAt(removeIndex);
      }
      cv.endUpdate();
    } catch (error) {
      // sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * 画面項目設定
   */
  setGridItems = () => {
    for (const key of Object.keys(kenViews)) {
      this._gridItems[key] = {...kenViews[key]};

      if (this._gridItems[key].dataType == 'cellMaker') {
        if (this._gridItems[key].binding == 'tsButton') {
          this._gridItems[key].text='調査入力';
        }
        if (this._gridItems[key].binding == 'tkButton') {
          this._gridItems[key].text='点検入力';
        }
      }

      // 再調査ありの場合、再調査のButtonを表示する。
      // 再調査なしの場合、何も表示しない。
      if (this._gridItems[key].dataType == 'cellMaker' && this._gridItems[key].binding == 'tsSaiTyosa') {
        this._gridItems[key].text='再調査';
      }
      this._fields.push(this._gridItems[key].binding);

      if (key === 'tsTkUserName') {
        let dataMap = ['田中  一郎', '田中  二郎', '田中  三郎'];
        this._gridItems[key].dataMap = dataMap;
      }
      if (key === 'tsTkDate') {
        let dataMap = ['2026/11', '2026/12', '2027/1', '2027/2', '2027/3'];
        this._gridItems[key].dataMap = dataMap;
      }
    }
    // お客さま名のリンクのクリック
    this._gridItems['customerName'].click = (e, ctx) => {
      this.doClickLinkCustomerNo(ctx.item.supplyPointNo, ctx.item.customerType);
    };


    // 調査入力をクリック
    this._gridItems['tsButton'].click = (e, ctx) => {
      this.doClickButtonTs(ctx.item);
    };

    // 再調査入力をクリック
    this._gridItems['tsSaiTyosa'].click = (e, ctx) => {
      this.doClickButtonTs(ctx.item.supplyPointNo);
    };

    // 共用組番号入力をクリック
    this._gridItems['togeNo'].click = (e, ctx) => {
      // this.openDntYoti(e, ctx);
      this.doClickButtonTogeNo(ctx.item.supplyPointNo);
    };

    // 点検入力をクリック
    this._gridItems['tkButton'].click = (e, ctx) => {
      this.doClickButtonTk(ctx.item);
    };

    // 調査工程状況のリンクのクリック
    this._gridItems['tsStatus'].click = (e, ctx) => {
      this.doClickLinkTsTkKotei(ctx.item.supplyPointNo, ctx.item.customerName, '1');
    };

    // 点検工程状況のリンクのクリック
    this._gridItems['tkStatus'].click = (e, ctx) => {
      this.doClickLinkTsTkKotei(ctx.item.supplyPointNo, ctx.item.customerName, '2');
    };

    // 持出状況のリンクのクリック
    this._gridItems['dataMotiDasi'].click = (e, ctx) => {
      this.doClickLinkDataMotiDasi(ctx.item.supplyPointNo,
          ctx.item.customerName);
    };
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
  // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
      e.cell.style['box-shadow'] = '';
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      const customerBindings = ['customerName', 'supplyPointNo'];
      const dtNoBindings = ['dtNo', 'slName'];
      const tsSaiTyosaBindings = ['tsSaiTyosa', 'tkKeki'];
      const statusBindings = ['tkStatus', 'tsStatus'];
      const memo = ['tkMemo', 'tsMemo'];
      const userName = ['tkUserName', 'tsUserName'];

      // お客さま名のセルの背景の色を付ける
      // 追加交付：緑 customerType === '1'
      // 異動あり（お客さま）：赤 customerType === '2'
      // 異動あり（電柱番号）：赤 customerType === '3'
      // 全使撤：グレー customerType === '4'
      // 箇所追加：青 customerType === '5'
      // if (col && (customerBindings.includes(col.binding)||
      // dtNoBindings.includes(col.binding))) {
      if (data.customerType === '1') {
        e.cell.style.backgroundColor = '#B8E785';
        // e.cell.style['box-shadow'] = '#99ffcc 0px 0px 4px 0px inset';
        // e.cell.style.backgroundColor = '#00FF00';
        // e.cell.style['opacity'] = '0.4';
        // if (e.cell.children[0].id === 'customerName') {
        //   e.cell.innerHTML = '<div >'+data.customerName+'</div>';
        // }
      }
      if (data.customerType === '5') {
        e.cell.style.backgroundColor = '#AFDEFA';
        // e.cell.style['box-shadow'] = '#ccffff 0px 0px 4px 0px inset';
        // e.cell.style.backgroundColor = '#0000FF';
        // e.cell.style['opacity'] = '0.4';
      }
      // }
      if (col && customerBindings.includes(col.binding)) {
        if (data.customerType === '2') {
          e.cell.style.backgroundColor = '#FF9393';
          // e.cell.style['box-shadow'] = '#cc9999 0px 0px 4px 0px inset';
          // e.cell.style.backgroundColor = '#FF0000';
          // e.cell.style['opacity'] = '0.4';
        }
      }

      if (col && dtNoBindings.includes(col.binding)) {
        if (data.customerType === '3') {
          e.cell.style.backgroundColor = '#FF9393';
          // e.cell.style['box-shadow'] = '#cc9999 0px 0px 4px 0px inset';
          // e.cell.style.backgroundColor = '#FF0000';
          // e.cell.style['opacity'] = '0.4';
        }
      }
      if (data.customerType === '4') {
        e.cell.style.backgroundColor = 'gray';
        // e.cell.style['box-shadow'] = '#1eecff 0px 0px 4px 0px inset';
      }
      // 再調査ではない場合、再調査のボタンを表示しない
      if (col && tsSaiTyosaBindings.includes(col.binding)) {
        if (e.cell.childElementCount === 1) {
          if (data.tsSaiTyosa !== '1' && e.cell.children[0].id === 'btntsSaiTyosa') {
            e.cell.innerHTML = '<div ></div>';
          }
        }
      }

      // 否決の場合、背景は赤で表示する。
      if (col && statusBindings.includes(col.binding)) {
        if (e.cell.childElementCount === 1) {
          if (data.hiKetuFlagTs === 'true' && e.cell.children[0].id === 'linktsStatus') {
            e.cell.style.backgroundColor = '#ff0000';
          }
          if (data.hiKetuFlagTk === 'true' && e.cell.children[0].id === 'linktkStatus') {
            e.cell.style.backgroundColor = '#ff0000';
          }
        }
      }
      // if (col && ((col.binding === 'tkStatus' &&
      //   data.hiKetuFlagTs === true) )) {
      //   // e.cell.style.backgroundColor = '#fff0f5';
      //   e.cell.style.backgroundColor = '#ff0000';
      // }

      if (col && memo.includes(col.binding)) {
        if (e.cell.className.includes('wj-record-start')) {
          let note = data.notes ? data.notes['tkMemo'] : null;
          // toggleClass(e.cell, 'wj-has-notes-tkts', note != null);
          if (note != null) {
            this.tooltip.setTooltip(e.cell, note);
          }
        }
        if (e.cell.className.includes('wj-record-end')) {
          let note = data.notes ? data.notes['tsMemo'] : null;
          // toggleClass(e.cell, 'wj-has-notes', note != null);
          if (note != null) {
            this.tooltip.setTooltip(e.cell, note);
          }
        }
      }

      if (col && userName.includes(col.binding)) {
        if (e.cell.className.includes('wj-record-start')) {
          let note = data.notes ? data.notes['tkUserName'] : null;
          // toggleClass(e.cell, 'wj-has-notes', note != null);
          if (note != null) {
            this.tooltip.setTooltip(e.cell, note);
          }
        }
        if (e.cell.className.includes('wj-record-end')) {
          let note = data.notes ? data.notes['tsUserName'] : null;
          // toggleClass(e.cell, 'wj-has-notes', note != null);
          if (note != null) {
            this.tooltip.setTooltip(e.cell, note);
          }
        }
      }
      if (data.supplyPointNo === this.state.tkInfo.supplyPointNo &&
          this.state.tkInfo.btnFlag === '1') {
        data.tkHikomiSen = this.state.tkInfo.tkHikomiSen;
        data.tkKeki = this.state.tkInfo.tkKeki;
        data.tkDtNo = this.state.tkInfo.tkDtNo;
        data.tkMemo = this.state.tkInfo.tkMemo;
      }
    }
  };

  /**
     * 初期値設定
     */
  setInitValue = () => {
    for (const key of Object.keys(this._gridItems)) {
      let initValue = null;
      this.items[this._gridItems[key].binding] = initValue;
      if (this._gridItems[key].isPopup) {
        this.popupItems[this._gridItems[key].binding] = initValue;
      }
    }
  };

  /**
   * 県一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      // rowHeaderType: 'check',
      filterOn: true,
      filters: filtersBindings,
      // frozenRows: 3,
      rowHeaderType: 'check',
      headersVisibility: 'All',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      validateEdits: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto'},
      screenId: 'B1000001',
      isReadOnly: false,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
    };

    const component = createComponents(this._gridItems, false);
    // const _popupComponents = createPopupData(this._gridItems);
    return (
      <React.Fragment>
        <CustomMultiRow ref={this.gridRef} {...props}>
          {component}
        </CustomMultiRow>
        {/* <GridPopup headers={this.state.popupHeader}
          items={_popupComponents}
          isDisabled={this.state.isDisabled}
          size="1200px"/> */}
      </React.Fragment>
    );
  }

  /**
   * 一覧お客さま名リンククリック時
   * @param {*} supplyPointNo 供給地点特定番号
   * @param {*} customerType 箇所追加区分「４」
   */
  doClickLinkCustomerNo = async (supplyPointNo, customerType) => {
    try {
      // let params = {
      //   supplyPointNo,
      //   mod: 'C',
      // };
      if (customerType ==='5') {
        // 調査・点検画面に遷移
        this.displayRowAdd();
      } else {
        // お客さま情報に遷移
        // setSessionObject(GMN.CUSTOMER_INFO_INFO.id, params);
        // window.open(GMN_PATH.CUSTOMER_INFO_INFO, '_blank');
        this.displayCustomerInfo();
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 一覧リンククリック時
   * @param {*} supplyPointNo 供給地点特定番号
   * @param {*} customerName お客さま名
   */
  doClickLinkDataMotiDasi = async (supplyPointNo, customerName) => {
    try {
      // let params = {
      //   supplyPointNo,
      //   customerName,
      //   mod: 'C',
      // };
      // データ持出履歴に遷移
      // setSessionObject(GMN.TSTK_MODASI_HISTORY_LIST.id, params);
      // this.props.navigate(GMN_PATH.TSTK_MODASI_HISTORY_LIST);
      this.displayMdHistory();
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 工程状況リンククリック時
   * @param {*} supplyPointNo 供給地点特定番号
   * @param {*} customerName お客さま名
   * @param {*} tstkType 調査・点検区分
   */
  doClickLinkTsTkKotei = async (supplyPointNo, customerName, tstkType) => {
    try {
      // let params = {
      //   supplyPointNo,
      //   customerName,
      //   tstkType: tstkType,
      // };
      // // 工程状況画面に遷移する
      // setSessionObject(GMN.TSTK_KOTEI_LIST.id, params);
      // this.props.navigate(GMN_PATH.TSTK_KOTEI_LIST);
      // 承認状況画面を表示
      this.displayApprovalStatus();
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 一覧調査入力ボタンクリック時
   * @param {*} item 調査データ
   */
  doClickButtonTs = async (item) => {
    try {
      // let params = {
      //   supplyPointNo,
      //   tstkType: '2',
      // };
      // // 調査詳細画面に遷移
      // setSessionObject(GMN.TSTK_MODASI_HISTORY_LIST.id, params);
      // this.props.navigate(GMN_PATH.TSTK_MODASI_HISTORY_LIST);
      this.openTsInfo(item);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };
  /**
   * 一覧点検入力ボタンクリック時
   * @param {*} item 点検データ
   */
  doClickButtonTk = async (item) => {
    try {
      // let params = {
      //   supplyPointNo,
      //   mod: 'C',
      // };
      // // 点検詳細画面に遷移
      // setSessionObject(GMN.TSTK_MODASI_HISTORY_LIST.id, params);
      // this.props.navigate(GMN_PATH.TSTK_MODASI_HISTORY_LIST);
      this.openTkInfo(item);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };
  /**
   * 一覧共用設定ボタン／クリック時
   * @param {*} dtNo 電柱番号
   */
  doClickButtonTogeNo = async (dtNo) => {
    try {
      // let params = {
      //   supplyPointNo,
      //   mod: 'C',
      // };
      // // 点検詳細画面に遷移
      // setSessionObject(GMN.TSTK_MODASI_HISTORY_LIST.id, params);
      // this.props.navigate(GMN_PATH.TSTK_MODASI_HISTORY_LIST);
      this.displaySharedSetting(dtNo);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };


  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              fullWidth
              type="text"
              required={true}
              validate={[

              ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5100}>{'広島NWC'}</MenuItem>
              <MenuItem value={5110}>{'福山NWC'}</MenuItem>
              <MenuItem value={5120}>{'尾道NWC'}</MenuItem>
              <MenuItem value={5130}>{'三次NWC'}</MenuItem>
              <MenuItem value={5140}>{'呉NWC'}</MenuItem>
              <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
              <MenuItem value={5170}>{'廿日市NWC'}</MenuItem>
              <MenuItem value={5190}>{'東広島NWC'}</MenuItem>
              <MenuItem value={5250}>{'矢野NWC '}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujoOld" item xs={12} sm={2}>
            <Field
              id="zigyoujoOld"
              name="zigyoujoOld"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="旧NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
              <MenuItem value={5170}>{'廿日市NWC'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4510}>{'福山支'}</MenuItem>
              <MenuItem value={4580}>{'府中支'}</MenuItem>

            </Field>
          </Grid>

        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="supplyPointNo" item xs={12} sm={3}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="供給地点特定番号"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
            </Field>
          </Grid>
          <Grid key="customerName" item xs={12} sm={2} >
            <Field
              id="customerName"
              name="customerName"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="お客さま名"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
            </Field>
          </Grid>
          <Grid key="tsTkUserId" item xs={12} sm={2}>
            <Field
              id="tsTkUserId"
              name="tsTkUserId"
              component={renderTextField}
              className="fields"
              label="担当者"
              type="text"
              fullWidth
              required={false}
              validate={[
                validateRule.maxLength(30),
              ]}
            />
          </Grid>
          <Grid key="reportDate" item xs={12} sm={4}>
            <div style={{position: 'relative'}}>
              <Field
                id="tsTkDateFrom"
                name="tsTkDataFrom"
                // accessibilitylabel={option.id + 'From'}
                label="調査・点検年月日"
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                // validate={[
                //   validateRule.date,
                //   validateRule.correctFromDate(values ? values[option.id + 'To'] : null),
                // ]}
              />
              <span className="wave">～</span>
              <Field
                id="tsTkDateTo"
                name="tsTkDateTo"
                // accessibilitylabel={option.id + 'To'}
                label={<React.Fragment />}
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                // validate={[
                //   validateRule.date,
                //   validateRule.correctDate(values ? values[option.id + 'From'] : null),
                // ]}
              />
            </div>
          </Grid>

        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="taisyoYM" item xs={12} sm={2}>
            <Field
              id="taisyoYM"
              name="taisyoYM"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="実施年月"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4}>{'2027/4'}</MenuItem>
              <MenuItem value={5}>{'2027/5'}</MenuItem>
              <MenuItem value={6}>{'2027/6'}</MenuItem>
              <MenuItem value={7}>{'2027/7'}</MenuItem>
              <MenuItem value={8}>{'2027/8'}</MenuItem>
              <MenuItem value={9}>{'2027/9'}</MenuItem>
              <MenuItem value={10}>{'2027/10'}</MenuItem>
              <MenuItem value={11}>{'2027/11'}</MenuItem>
              <MenuItem value={12}>{'2027/12'}</MenuItem>
              <MenuItem value={1}>{'2028/1'}</MenuItem>
              <MenuItem value={2}>{'2028/2'}</MenuItem>
              <MenuItem value={3}>{'2028/3'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tsStatus" item xs={12} sm={3}>
            <Field
              id="tsStatus"
              name="tsStatus"
              // variant="standard"
              component={renderSelectMultiLine}
              className="fields"
              label="調査・点検ステータス"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={10}>{'未着手'}</MenuItem>
              <MenuItem value={20}>{'調査中／点検中'}</MenuItem>
              <MenuItem value={30}>{'調査済／点検済'}</MenuItem>
              <MenuItem value={40}>{'報告中'}</MenuItem>
              <MenuItem value={50}>{'確認中'}</MenuItem>
              <MenuItem value={60}>{'承認中'}</MenuItem>
              <MenuItem value={90}>{'完了'}</MenuItem>
            </Field>
          </Grid>
          {/* <Grid key="tkStatus" item xs={12} sm={2}>
            <Field
              id="tkStatus"
              name="tkStatus"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="点検ステータス"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={10}>{'調査（点検）シート作成'}</MenuItem>
              <MenuItem value={20}>{'未着手'}</MenuItem>
              <MenuItem value={30}>{'点検中'}</MenuItem>
              <MenuItem value={40}>{'報告中'}</MenuItem>
              <MenuItem value={50}>{'工組承認待ち'}</MenuItem>
              <MenuItem value={60}>{'報告内容確認中'}</MenuItem>
              <MenuItem value={70}>{'NWC承認待ち'}</MenuItem>
              <MenuItem value={90}>{'完了'}</MenuItem>
            </Field>
          </Grid> */}
          <Grid key="motiDasiStatus" item xs={12} sm={2}>
            <Field
              id="motiDasiStatus"
              name="motiDasiStatus"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="持出状況"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'未'}</MenuItem>
              <MenuItem value={2}>{'持出中'}</MenuItem>
              <MenuItem value={3}>{'解除'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="reportDate" item xs={12} sm={4}>
            <div style={{position: 'relative'}}>
              <Field
                id="reportDateFrom"
                name="reportDateFrom"
                // accessibilitylabel={option.id + 'From'}
                label="報告年月日"
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                // validate={[
                //   validateRule.date,
                //   validateRule.correctFromDate(values ? values[option.id + 'To'] : null),
                // ]}
              />
              <span className="wave">～</span>
              <Field
                id="reportDateTo"
                name="reportDateTo"
                // accessibilitylabel={option.id + 'To'}
                label={<React.Fragment />}
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                // validate={[
                //   validateRule.date,
                //   validateRule.correctDate(values ? values[option.id + 'From'] : null),
                // ]}
              />
            </div>
          </Grid>

        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="tenKenFuryo" item xs={12} sm={2}>
            <Field
              id="tenKenFuryo"
              name="tenKenFuryo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="点検不良"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'不良あり'}</MenuItem>
              <MenuItem value={2}>{'不良なし'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="tyousaRyouCd" item xs={12} sm={2}>
            <Field
              id="tyousaRyouCd"
              name="tyousaRyouCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査良否区分"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'良'}</MenuItem>
              <MenuItem value={2}>{'不良'}</MenuItem>
              <MenuItem value={3}>{'不能'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="smdsZtiKbn" item xs={12} sm={2}>
            <Field
              id="smdsZtiKbn"
              name="smdsZtiKbn"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="否決"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'否決あり'}</MenuItem>
              <MenuItem value={2}>{'否決なし'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="everyYearTs" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="everyYearTs"
                  name="everyYearTs"
                  component={renderCheckbox}
                  label="毎年調査"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid key="tsSaiTyosa" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="tsSaiTyosa"
                  name="tsSaiTyosa"
                  component={renderCheckbox}
                  label="再調査"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="blockNo" item xs={12} sm={4}>
            <Field
              id="blockNoFrom"
              name="blockNoFrom"
              label="ブロック番号"
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
            <span className="wave">～</span>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              label={<React.Fragment />}
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="senroCode" item xs={12} sm={1}>
            <Field
              id="senroCode"
              name="senroCode"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="線路コード"
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="senroName" item xs={12} sm={3}>
            <Autocomplete
              ref={`autocomplete`}
              // freeSolo
              id="autocompleteSenroName"
              disableClearable
              options={autoCompleteItems.map((option) => option.senroMskn)}
              size='small'
              disabled={this.state.senroNameDisabled}
              fullWidth
              className="dntFields"
              // sx={{width: '320px'}}
              onBlur={this.handleSenroNameChange}
              renderInput={(params) => (
                <Field
                  id="senroName"
                  name="senroName"
                  component={renderTextField}
                  label="線路名"
                  required={false}
                  validate={[
                  ]}
                  {...params}
                />
              )}
            />
          </Grid>
          <Grid key="dntNo1" item xs={12} sm={1}>
            <Field
              id="dntNo1"
              name="dntNo1"
              component={renderTextField}
              className="dntFields"
              label="幹線"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo2" item xs={12} sm={1}>
            <Field
              id="dntNo2"
              name="dntNo2"
              component={renderTextField}
              className="dntFields"
              label="第１分岐"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo3" item xs={12} sm={1}>
            <Field
              id="dntNo3"
              name="dntNo3"
              component={renderTextField}
              className="dntFields"
              label="第２分岐"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo4" item xs={12} sm={1}>
            <Field
              id="dntNo4"
              name="dntNo4"
              component={renderTextField}
              className="dntFields"
              label="第３分岐"
              fullWidth
              type="text"
              required={false}
              onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="bunki" item xs={12} sm={2}>
            <Field
              id="bunki"
              name="bunki"
              component={renderSelect}
              className="dntFields"
              label="分岐有無"
              fullWidth
              required={false}
              // onChange={this.conditionChange}
              sx={{width: '120px'}}
            >
              {/* {bunkiList} */}
              <MenuItem value={1}>{'分岐無'}</MenuItem>
              <MenuItem value={2}>{'分岐有'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="tdhknAddCd" item xs={12} sm={6}>
            <Field
              id="tdhknAddCd"
              name="tdhknAddCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="都道府県"
              type="text"
              sx={{width: '20%'}}
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={31}>{'鳥取県'}</MenuItem>
              <MenuItem value={32}>{'島根県'}</MenuItem>
              <MenuItem value={33}>{'岡山県'}</MenuItem>
              <MenuItem value={34}>{'広島県'}</MenuItem>
              <MenuItem value={35}>{'山口県'}</MenuItem>
            </Field>

            <Field
              id="azatmApart"
              name="azatmApart"
              // variant="standard"
              component={renderTextField}
              // className="fields"
              label="住所"
              sx={{width: '75%'}}
              type="text"
              required={false}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * Viewのヘッダボタン
   * @return {JSX.Element}
   */
  renderTopBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
        sx={{marginLeft: '5px'}}
      >
        <Grid key="key1001LineAdd" item>
          <PositiveButton
            id="btn1001LineAdd"
            onClick={this.displayRowAdd}
            variant="contained"
            startIcon={<AddIcon />}
            // size="large"
          >
            <span>調査・点検箇所追加</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001LineDelete" item>
          <DangerButton
            id="btn1001LineDelete"
            onClick={this.doDelete}
            variant="contained"
            startIcon={<DeleteIcon />}
            disabled={this.state.buttonDisabled}
          >
            <span>調査・点検箇所削除</span>
          </DangerButton>
        </Grid>
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.displayTkResultAll}
            variant="contained"
            // startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>点検結果一括</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        <Grid key="keyBFA10102GDesignFile" item>
          <Typography variant="h6" display="block">
            <MuiTooltip content={
              this.renderTkResultAllTooltip()
            }>
              <InfoOutlined/>
            </MuiTooltip>
          </Typography>
        </Grid>
        <Grid key="key1001Kyoyou" item>
          <PositiveButton
            id="key1001Kyoyou"
            onClick={this.doClickButtonTogeNo}
            variant="contained"
            // startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>共用設定</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            // startIcon={<SaveIcon />}
            // size="large"
          >
            <span>調査・点検箇所紐付</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            // startIcon={<SaveIcon />}
            // size="large"
          >
            <span>持出解除</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        {/* <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            startIcon={<GetAppIcon />}
            // size="large"
          >
            <span>不良報告書出力</span>
          </PositiveButton>
        </Grid> */}
        <Grid key="keyBFA10102GDesignFile" item>
          <Typography variant="h6" display="block">
            <font size="2">※背景色</font>
            <MuiTooltip content={
              <React.Fragment>
                <div style={{background: '#FF9393', height: '30px', width: '160px', textAlign: 'left', padding: '5px'}}>異動あり</div>
                <div style={{background: '#B8E785', height: '30px', width: '160px', textAlign: 'left', padding: '5px'}}>調査・点検箇所追加交付</div>
                <div style={{background: '#ABE3FF', height: '30px', width: '160px', textAlign: 'left', padding: '5px'}}>調査・点検箇所追加</div>
                <div style={{background: 'gray', height: '30px', width: '160px', textAlign: 'left', padding: '5px'}}> 全使撤</div>
              </React.Fragment>
            }>
              <InfoOutlined/>
            </MuiTooltip>
          </Typography>
        </Grid>
        {/* <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            // startIcon={<SaveIcon />}
            // size="large"
          >
            <span>全使撤</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            // startIcon={<SaveIcon />}
            // size="large"
          >
            <span>特定不能</span>
          </PositiveButton>
        </Grid> */}
      </Grid>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {/* <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSave}
            variant="contained"
            startIcon={<SaveIcon />}
            // size="large"
          >
            <span>一時保存</span>
          </PositiveButton>
        </Grid> */}
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSave}
            variant="contained"
            startIcon={<SaveIcon />}
            // size="large"
          >
            <span>予定割当</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        {/* <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSave}
            variant="contained"
            startIcon={<SaveIcon />}
            // size="large"
          >
            <span>登録</span>
          </PositiveButton>
        </Grid> */}
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            startIcon={<SaveIcon />}
            // size="large"
          >
            <span>報告</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        {/* <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doApprove}
            variant="contained"
            startIcon={<CheckCircle />}
            // size="large"
          >
            <span>確認</span>
          </PositiveButton>
        </Grid> */}
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={()=>{
              this.displayApprovalComment(false, '1');
            }}
            variant="contained"
            startIcon={<CheckCircle />}
            // size="large"
          >
            <span>承認</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <DangerButton
            id="btn1001CreateTen4"
            onClick={()=>{
              this.displayApprovalComment(true, '2');
            }}
            variant="contained"
            startIcon={<Cancel />}
            // size="large"
          >
            <span>否決</span>
          </DangerButton>
        </Grid>
      </Grid>
    );
  };

  /**
   * 点検結果一括ツールチップ
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderTkResultAllTooltip() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Typography sx={{margin: '20px 20px 0px 20px'}}>
            <font size="2">番号
            </font>
          </Typography>
          <Typography sx={{margin: '20px 20px 0px 20px'}}>
            <font size="2">引込線&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '20px 20px 0px 20px'}}>
            <font size="2">計器
            </font>
          </Typography>
        </Grid>
        <Divider variant="middle" />
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">①&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">良(001)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">入力なし
            </font>
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">②&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">入力なし&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">良(101)
            </font>
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">③&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">良(001)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">良(101)
            </font>
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">④&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">不能(921)&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">不要(932)
            </font>
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">⑤&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">不能(912)&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">入力なし
            </font>
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">⑥&nbsp;&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">不能(913)&nbsp;&nbsp;
            </font>
          </Typography>
          <Typography sx={{margin: '10px 20px 0px 20px'}}>
            <font size="2">入力なし
            </font>
          </Typography>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    // 調査・点検登録・報告一覧から遷移かメニューから遷移か判断
    const storage = getSessionObject(GMN.TSTK_KASYO_LIST.id);
    let lastMenu = '';
    if (!isNull(storage) && !isNull(storage.lastMenu) ) {
      lastMenu = storage['lastMenu'].id;
    }

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={ lastMenu === GMN.TSTK_RESULT_REPORT_LIST.id ? transitionListReport : transitionList} />
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={false}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '10px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
            spacing={1}
            direction={'row'}
          >
            {this.renderTopBtn()}
          </Grid>
          {/* <div style={{marginBottom: '0px'}} />
          <Divider variant="middle" /> */}
          <div style={{marginBottom: '10px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
            direction={'row'}
          >
            {this.renderTable()}
          </Grid>
        </MainContainer>
        <MdHistory
          openState={this.state.showMdHistoryModal}
          supplyPointNo={this.state.showMdHistoryModal}
          modalKey={this.state.modalKey}
          handleClose={this.closeMdHistory}
        />
        {this.state.dntYotiInfo.supplyPointNo && this.state.modalOpenDntYoti &&
        <YotiInfo
          supplyPointNo={this.state.dntYotiInfo.supplyPointNo}
          customerName={this.state.dntYotiInfo.customerName}
          editMode={false}
          modalOpen={this.state.modalOpenDntYoti}
          closeButton={this.closeDntYoti}
        />}
        <ApprovalStatus
          openState={this.state.showApprovalStatusModal}
          handleExec={this.getInitializeData}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalStatus}/>
        <ApprovalComment
          openState={this.state.showApprovalCommentModal}
          tstkFlag={this.state.tstkFlag}
          approvalType={this.state.approvalType}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalComment}/>
        <RowAdd
          openState={this.state.showRowAddModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          handleClose = {this.closeRowAdd}
          handleExec={this.getRowAdd}
        />
        {/* {this.state.showSharedSettingModal && */}
        <SharedSetting
          openState={this.state.showSharedSettingModal}
          dtNo={this.state.dtNo}
          modalKey={this.state.modalKey}
          handleClose={this.closeSharedSetting}
          handleExec={this.sharedSettingExe}
          // openState={this.state.showSharedSettingModal}
          // handleClose = {this.closeSharedSetting}
          // hikikomiNo={this.state.hikikomiNo}
        />
        {this.state.showCustomerInfoModal &&
        <CustomerInfo
          openState={this.state.showCustomerInfoModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          handleClose = {this.closeCustomerInfo}
          // handleExec={this.getRowAdd}
        />
        }
        <TkResultAll
          openState={this.state.showTkResultAllModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          handleClose = {this.closeTkResultAll}
          handleExec={this.getTkResultAll}
        />
        {this.state.modalOpenTkInfo &&
        <TkInfo
          supplyPointNo={this.state.tkInfo.supplyPointNo}
          tkStatus={this.state.tkInfo.tkStatus}
          modalOpen={this.state.modalOpenTkInfo}
          closeButton={this.closeTkInfo}
        />}
        {this.state.modalOpenTsInfo &&
        <TsInfo
          supplyPointNo={this.state.tsInfo.supplyPointNo}
          tsKasyo={this.state.tsInfo.tsKasyo}
          modalOpen={this.state.modalOpenTsInfo}
          closeButton={this.closeTsInfo}
        />}
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYear: '1',
      tyousakikan: '5000',
      tskkJgyosyo: '4510',
    },
    // initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

